<div class="container">
  <img class="image" [src]="placeholderUrl" alt="image preview" />
  <div class="spinner-overlay" *ngIf="isLoading">
    <mat-spinner></mat-spinner>
  </div>
  <div class="overlay">
    <button
      type="button"
      mat-button
      (click)="fileInput.click()"
      class="overlay-content primary-color"
      aria-label="Edit image"
    >
      {{ title }}
      <mat-icon>edit</mat-icon>
    </button>
  </div>
</div>

<input
  style="display: none"
  #fileInput
  type="file"
  accept="{{ acceptedTypes }}"
  (change)="onFileChanged($event)"
/>
